export default class TicketCategoriaStatusChipEnum {
    static Ativos = 1
    static Novos = 2
    static Andamento = 3
    static Inativos = 4
    static Resolvidos = 5
    static Finalizados = 6
}
